import React, { FC } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'react-recompose';
import { ManagePools as SettingsModule } from '@dev/ee-modules';
import { push as Push } from 'redux-first-history';
import { ApplicationState as State } from '@/store';
import { ShowDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { LoadPools, UpdatePool, AddNewPool, DeletePool } from '@/store/pools/actions';
import { SettingsPaths } from '@/services/dictionaries/Paths';
import Props from '../PrivateIPInterface';

const mapState = (state: State, ownProps: Props): Props => ({
    ...ownProps,
    account: state.account,
    browser: state.browser,
    dialog: state.dialog,
    pools: state.pools,
});
const dispatchProps = {
    ShowDialog,
    LoadPools,
    AddNewPool,
    UpdatePool,
    DeletePool,
    Push,
};
interface DispatchProps {
    ShowDialog(params: ShowDialogParams): void;
    LoadPools(): void;
    AddNewPool(name: string, description: string): void;
    UpdatePool(oldName: string, name: string, description: string): void;
    DeletePool(poolName: string): void;
    Push(url: string): void;
}

type ExtendedProps = Props & DispatchProps;

const ManagePools: FC<ExtendedProps> = (props: ExtendedProps): JSX.Element => (
    <SettingsModule paths={SettingsPaths} {...props} />
);

export default compose(
    withTranslation('settings'),
    connect<Props, DispatchProps>(mapState, dispatchProps)
)(ManagePools);
